// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "paper-35ZGh";
var _4 = "header-1l8q0";
var _5 = "content-3OwmA";
var _6 = "dialogContent_root-2Fvmv";
var _7 = "title-3O2xj";
var _8 = "footer-hKtPx";
var _9 = "buttonsExtra-2DRWO";
var _a = "buttons-3iZsX";
var _b = "cancelButton-1jS3c";
var _c = "disabled-2Sa85";
var _d = "confirmButton-2MJT3";
var _e = "small-2PUqi";
var _f = "medium-3YtpY";
var _10 = "large-EgHCg";
var _11 = "xlarge-Y34w_";
var _12 = "fullscreen-ukq6y";
export { _1 as "__esModule", _2 as "mobile", _3 as "paper", _4 as "header", _5 as "content", _6 as "dialogContent_root", _7 as "title", _8 as "footer", _9 as "buttonsExtra", _a as "buttons", _b as "cancelButton", _c as "disabled", _d as "confirmButton", _e as "small", _f as "medium", _10 as "large", _11 as "xlarge", _12 as "fullscreen" }
export default { "__esModule": _1, "mobile": _2, "paper": _3, "header": _4, "content": _5, "dialogContent_root": _6, "title": _7, "footer": _8, "buttonsExtra": _9, "buttons": _a, "cancelButton": _b, "disabled": _c, "confirmButton": _d, "small": _e, "medium": _f, "large": _10, "xlarge": _11, "fullscreen": _12 }
